import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon, SweetAlertOptions } from "sweetalert2";

@Injectable({
  providedIn: 'root'
})
export class SwalService {

  error(message: string, icon: SweetAlertIcon = 'error') {
    Swal.fire({
      title: 'La Colonial',
      html: message,
      icon,
      confirmButtonColor: '#9A0113'
    })
  }

  confirm(message: string, title?: string, options?: SweetAlertOptions) {
    return Swal.fire({
      title: title,
      html: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#9A0113',
      cancelButtonText: 'Cancelar',
      ...options
    })
  }

  showLoading(message?: string) {
    Swal.fire({
      html: message,
      allowOutsideClick: false,
      didOpen() {
        Swal.showLoading()
      }
    })
  }

  success(message?: string, options?: SweetAlertOptions) {
    return Swal.fire({
      html: message,
      icon: 'success',
      confirmButtonColor: '#9A0113',
      didOpen() {
        Swal.hideLoading()
      },
      ...options
    })
  }

  dismiss() {
    Swal.close()
  }

  fire(options: SweetAlertOptions) {
    return Swal.fire({
      confirmButtonColor: '#9A0113',
      ...options
    })
  }
}
